import React from "react";
import { Dropdown } from 'primereact/dropdown';
import useAttendance from "../../hooks/useAttendance";
import _ from 'lodash'
import { FormattedDateString } from "../../utilities/DateHelper";

const ProClientAttendance = ({bed})=>{
    const {data:{filter, attendanceOptions}, actions:{MarkAttendance}} = useAttendance({refreshTree:false})
   
    const selectedAttendanceTemplate = (option, props) => {
        if (option) {
            return (
                <div className="attendance-item">                   
                    <div>{option.name}</div>
                </div>
            );
        }
        return (
            <div className="attendance-item">
                <div>{props.placeholder}</div>
            </div>
        );
    }

    const handleChange = async (e)=>{      
       const data = {
           clientId:bed.data.assignments[0].client.id,
           attendanceCodeId: e.value.id,
           bedId:bed.id,
           attendanceDate: FormattedDateString(filter.date),
           clientAttendanceId: (_.get(bed.data, "attendance") && _.get(bed.data.attendance[0], "clientAttendanceId")) || null
       }
       await MarkAttendance(data)      
    }

    return  <Dropdown style={{height:"30px", minWidth:"30%"}} valueTemplate={selectedAttendanceTemplate} placeholder="Attendance"
            value= {((_.get(bed.data, "attendance") && _.get(bed.data.attendance[0], "clientAttendanceStatus")) && bed.data.attendance[0].clientAttendanceStatus) || null} 
            options={attendanceOptions} onChange={handleChange} optionLabel="name" />

}

export default ProClientAttendance;